/** A custom field's form key is this prefix and the field's id. Dependency-free, so pure mapping code can read it. */
export const CUSTOM_FIELD_PREFIX = 'customField_';
